<script>
	export let classes = null
	export let bgImage = null
	export let bgCenter = 'bgCenter'
	export let bgColor = ''
</script>

<div
	style={bgImage ? "background-image: url('" + bgImage + "');" : ''}
	class="
	{bgCenter}
    {bgColor}
    {classes ?? ''}
    relative
    {bgColor}
    left-1/2
    w-screen
    -translate-x-1/2
    overflow-x-hidden
    "
>
	<slot />
</div>

<style>
	.bgCenter {
		background-position: top center;
	}
</style>
